function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "calendar-add_inline_svg__Subtraction_95",
  "data-name": "Subtraction 95",
  d: "M11.838 23H2.194A2.178 2.178 0 010 20.844V9.165a.545.545 0 01.549-.539h19.382a.544.544 0 01.548.539v2.128H20.4a8.967 8.967 0 00-9.035 8.876A8.74 8.74 0 0011.837 23zm8.093-15.812H.549A.545.545 0 010 6.649V5.032a2.178 2.178 0 012.194-2.157h2.194V.54A.545.545 0 014.937 0h1.828a.545.545 0 01.549.54v2.335h5.851V.54a.545.545 0 01.549-.54h1.829a.545.545 0 01.549.54v2.335h2.194a2.178 2.178 0 012.194 2.156v1.618a.544.544 0 01-.549.539z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "calendar-add_inline_svg__Subtraction_96",
  "data-name": "Subtraction 96",
  d: "M9.5 15A6.5 6.5 0 1116 8.5 6.507 6.507 0 019.5 15zM5.75 7.755v1.487h3v3.112h1.5V9.242h3V7.755h-3V4.643h-1.5v3.112z",
  transform: "translate(10.979 11.7)",
  fill: "#fff"
});

function SvgCalendarAddinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-add_inline_svg__Component_16_4",
    "data-name": "Component 16 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.98,
    height: 26.699,
    viewBox: "0 0 26.98 26.699"
  }, props), _ref, _ref2);
}

export default SvgCalendarAddinline;